import React, { useState, useMemo, memo, useCallback } from 'react';
const Modal = React.lazy(() => import('@components/common/Modal'));
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import cn from 'classnames';
import styles from './checksCommon.module.scss';
import style from './checksCart.module.scss';
import { TouchableButton, TouchableDiv } from '../common/Touchable/index';
import PrintMoveConfirmModal from './printMoveModal';
import TableConfirmationModal from './TableConfirmationModal';

const ConfirmationPop = (props) => {

  // Props Destructuring
  const {
    isOpen, onClose, pendingActionType,
    isCounter, serverAppTheme, menuItemsHashTable, seat, isDriveThru, isCallCenter, isOrderingPortrait
  } = props;

  // State Management
  const [selectedSeats, setSelectedSeats] = useState([]);
  const isTab = props?.seat?.tab;
  const [confirmPrint, setConfirmPrint] = useState(false)
  // React Hooks

  const handleType = useCallback(() => {
    const type = pendingActionType?.type;
    if ((isCounter || isDriveThru || isCallCenter) && type === 'unsentRepeat') return true;
    return !['sentMove', 'unsentMove', 'print', 'unsentRepeat', 'sentRepeat', 'sentMoveDiscount', 'sentMoveService'].includes(type);
  }, [pendingActionType?.type, isCounter, isDriveThru, isCallCenter]);

  const getGiftAndGameCard = useCallback(() => {
    let arr = []
    for (let index = 0; index < pendingActionType?.data?.selectedItem?.length; index++) {
      let data = pendingActionType?.data?.selectedItem[index];
      arr.push(menuItemsHashTable[data?.menuItemId]?.cardType)
      if (!data.isLinked && data.uniqueIdForLinkedItem) {
        let value = pendingActionType?.data.orders[0].items;
        for (let index = 0; index < value.length; index++) {
          const element = value[index];
          let orderjson = JSON.parse(element?.orderJson || "{}")
          if (orderjson.isLinked) {
            if (data.uniqueIdForLinkedItem === orderjson.uniqueIdForLinkedItem) {
              arr.push(menuItemsHashTable[orderjson.menuItemId]?.cardType)
            }
          }
        }
      }
    }
    return arr.includes(2) || arr.includes(1);
  }, [menuItemsHashTable, pendingActionType?.data]);

  

  const addRemoveSeats = useCallback((node) => {
    if (selectedSeats.indexOf(node) === -1 && selectedSeats.includes('table')) {
      setSelectedSeats([node]);
    } else if (selectedSeats.indexOf(node) === -1 && !selectedSeats.includes('table')) {
      if (getGiftAndGameCard()) {
        let a = []
        a[0] = node
        setSelectedSeats(a);
      } else {
        setSelectedSeats(selectedSeats.concat(node));
      }
    } else {
      setSelectedSeats(selectedSeats.filter((x) => x !== node));
    }
    if (node === 'table') {
      setSelectedSeats(['table']);
    }
  }, [selectedSeats, getGiftAndGameCard]);

  const sort = (array) => {
    return array.sort((a, b) => {
      return a.number - b.number;
    });
  };

  const ConfirmationPopUpStyle = useMemo (() => {
    const moveStyle = { padding: isOrderingPortrait ? '0px 12px' : '4px 60px 0px', alignItems: 'baseline'}
    const optionsPopUp = { backgroundColor: serverAppTheme?.popUp_bg, borderRadius: "16px", border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow, width: '486px', margin: 'auto', minHeight: '216px', padding: '1.5rem', position: 'relative' }
    const primText = { color: serverAppTheme ? serverAppTheme?.primary_text : 'white' }
    const noButton = { border: serverAppTheme?.cancleBtn_Border, background: serverAppTheme?.OFF_Premise_Btn, color: serverAppTheme?.cancleBtn_font }
    const yesButton = { backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }
    const tablePopUp = { position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', pointerEvents: 'auto', backgroundColor: serverAppTheme?.popUp_bg, backgroundClip: 'padding-box', height: '100%', border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow }
    const selectedSeatsStyle = { color: selectedSeats.includes('table') ? '#000' : serverAppTheme?.primary_text, width:isOrderingPortrait ? '235px' :'300px', height: '44px', border: serverAppTheme?.popupBorder, background: selectedSeats.includes('table') ? serverAppTheme?.selected : serverAppTheme?.OFF_Premise_Btn }
    const unSelectedSeatsStyle = (e) => {return { width:'100%', height: isOrderingPortrait ? '76px' : '85px', color: selectedSeats.includes(e.id) ? '#000' : serverAppTheme?.primary_text, border: selectedSeats.includes(e.id) ? 'none' : serverAppTheme?.popupBorder, background: selectedSeats.includes(e.id) ? serverAppTheme?.selected : serverAppTheme?.unselected }}
    const cancelButton = { backgroundColor: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font, borderRadius: '8px' }
    const printButton = { backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color, borderRadius: '8px', opacity: 1 }
    const ActionBtnContainer = {padding: isOrderingPortrait ? '0 12px' : '0 60px', bottom : isOrderingPortrait ? 0 : ''}
    return {moveStyle, optionsPopUp, primText, noButton, yesButton, tablePopUp, selectedSeatsStyle, unSelectedSeatsStyle, cancelButton, printButton, ActionBtnContainer}
  }, [serverAppTheme, selectedSeats])
  

  const getPendingActionMessage = () => {
    const { type, data } = pendingActionType;
  
    switch (type) {
      case 'send':
        return CUSTOM_MESSAGES().SINGLE_SEND_MSG;
      case 'delete':
        return CUSTOM_MESSAGES().SINGLE_DELETE_MSG;
      case 'send selected':
        return data.selectedItem.length > 1
          ? CUSTOM_MESSAGES().MULTIPLE_SEND_MSG
          : CUSTOM_MESSAGES().SINGLE_SELECTED_SEND_MSG;
      case 'delete selected':
        return data.selectedItem.length > 1
          ? CUSTOM_MESSAGES().MULTIPLE_DELETE_MSG
          : CUSTOM_MESSAGES().SINGLE_SELECTED_DELETE_MSG;
      case 'send all':
        return data.pendingItems.length > 1
          ? CUSTOM_MESSAGES().SEND_ALL_UNSENT_MSG
          : CUSTOM_MESSAGES().SINGLE_SEND_MSG;
      case 'delete all':
        return data.pendingItems.length > 1
          ? CUSTOM_MESSAGES().DELETE_ALL_UNSENT_MSG
          : CUSTOM_MESSAGES().SINGLE_DELETE_MSG;
      case 'unsentRepeat':
        return data.selectedItem.length > 1
          ? CUSTOM_MESSAGES().REPEAT_ITEMS
          : CUSTOM_MESSAGES().REPEAT_ITEM;
      default:
        return null;
    }
  };

  const message = useMemo(() => getPendingActionMessage(), [pendingActionType]);
  
  const stationName = seat?.stationName?.length > 8 ? seat?.stationName?.substring(0, 8).concat('...') : seat?.stationName;

  // HTML CSS CODE
  return ( 
    <>
    { handleType() ? (
    <Modal
      isOpen={isOpen}
      isModalCenter
      style = {ConfirmationPopUpStyle.optionsPopUp}
      customClass='h-100 w-100' customClass2='h-100 w-100 my-0'
      noBackground
    >
      <div className="justify-content-center align-items-center text-center h-100" 
      style={ConfirmationPopUpStyle.primText}
      >
        <div className="col-12 p-0 h-70 justify-content-center d-flex flex-column">
          <div className='col-12 fs_18 fw-700 text-center h-auto'>Are You Sure ?</div><br />
          <div className="col-12 px-0 fs_15 fw-400 text-center h-auto">
           {message}
          </div>
        </div><br />
        <div style={{ bottom: '1rem', left: '0' }} className="col-12 px-4 h-30 d-flex mt-auto justify-content-center align-items-center text-center position-absolute">
          <div className='col-6 pl-0 pr-1'>
            <TouchableButton className={cn(style.btnSecondary, "col-12 fs_24 fw-600 btn-44")} 
            style={ConfirmationPopUpStyle.noButton}
            type="button" onClick={() => { onClose('no');}}>
              {LABEL().NO}
            </TouchableButton>
          </div>
          <div className='col-6 pl-1 pr-0'>
            <TouchableButton className={cn(style.btnPrimary, "col-12 btn-ripple fs_24 fw-600")} 
            style={ConfirmationPopUpStyle.yesButton}
            type="button" onClick={() => { onClose('yes', [pendingActionType?.data?.seats[0]?.id]);}}>
              {LABEL().YES}
            </TouchableButton>
          </div>
        </div>
      </div>
    </Modal>

      ) : (
        <TableConfirmationModal
          isOpen={isOpen}
          serverAppTheme={serverAppTheme}
          ConfirmationPopUpStyle={ConfirmationPopUpStyle}
          isOrderingPortrait={isOrderingPortrait}
          isTab={isTab}
          stationName={stationName}
          pendingActionType={pendingActionType}
          seat={seat}
          selectedSeats={selectedSeats}
          addRemoveSeats={addRemoveSeats}
          getGiftAndGameCard={getGiftAndGameCard}
          sort={sort}
          onClose={onClose}
          setConfirmPrint={setConfirmPrint}
        />
      )}
      <PrintMoveConfirmModal
        confirmPrint={confirmPrint}
        setConfirmPrint={setConfirmPrint}
        pendingActionType={pendingActionType}
      />
    </>
  );
};

export default memo(ConfirmationPop);
